__turbopack_context__.v({
  "article": "_6_s3SG_article",
  "article__meta": "_6_s3SG_article__meta",
  "wrapper": "_6_s3SG_wrapper",
});
